import React, { useState, useEffect, useContext } from 'react';
import { Table, DatePicker } from "antd";
import $ from "jquery";
import moment from 'moment';
import 'moment-timezone';
import DateUtil from '../../util/DateUtil';
import DownloadReport from "../common/DownloadReport";
import LZString from 'lz-string';
import { Context } from '../../views/app';

const { RangePicker } = DatePicker;

function UptimeReport(props) {

    let appContex = useContext(Context);
    let user = appContex.user;

    let start_date = moment().add(-7, 'days');
    let end_date = moment();
    let date_defaults = [start_date, end_date];

    const [dates, setDates] = useState([start_date, end_date]);
    const [loading, setLoading] = useState(true);
    const [device_category, setDeviceCategory] = useState([]);
    const [location_alerts, setLocationAlerts] = useState([]);
    const [site_level, setSiteLevel] = useState([]);
    const [devices, setDevices] = useState([]);
    const [disconnected_gt, setDisconnectedGt] = useState([]);
    const [overallUptime, setOverallUptime] = useState(0);
    const report_columns = [
        {
            title: "Serial No",
            dataIndex: 'serial_no',
            render: (serial_no, record) => {
                let device_assetsn = devices && devices.find((d) => d.location_id === record.location_id) && devices.find((d) => d.location_id === record.location_id).device_assetsn;
                return <span>{device_assetsn === undefined ? (record.device_id === "0" ? record.location_id : record.device_id) : device_assetsn}</span>
            }
        },
        {
            title: "Zone Name",
            dataIndex: 'location_name',
            render: (location_name) => {
                return <span>{location_name}</span>
            }
        },
        {
            title: "Type",
            dataIndex: 'location_device_type',
            render: (location_device_type, record) => {
                let deviceCategory = device_category && device_category.find((r) => record.device_id === r.device_id) && device_category.find((r) => record.device_id === r.device_id).device_category;
                return <span>{location_device_type === "axis" ? (deviceCategory === "Z" ? "Bullet" : (deviceCategory === "PTZ" ? "PTZ" : "No data")) : "Gateway"}</span>
            }
        },
        {
            title: "Power",
            dataIndex: 'solar_pod_info',
            render: (solar_pod_info) => {
                return <span>{solar_pod_info && solar_pod_info.trim().length > 0 ? "Solar" : "Cable"}</span>
            }
        },
        {
            title: "Uptime",
            dataIndex: 'up_time',
            render: (up_time, record) => {
                let start_date_ts = DateUtil.getUnixTimeStampInUTC('America/Chicago', moment(dates[0]).format('YYYY-MM-DD'));
                let end_date_ts = DateUtil.getUnixTimeStampInUTC('America/Chicago', moment(dates[1]).format('YYYY-MM-DD'));
                let location_gt_level = site_level.filter((l) => l.location_id === record.location_id);
                let upPercentage = 0;
                if (record.location_unplugged) {
                    return <span>NA</span>
                }
                if (location_gt_level.length === 0) {
                    let dis_gateway = disconnected_gt && disconnected_gt.find((d) => d.device_id === record.device_id) && disconnected_gt.find((d) => d.device_id === record.device_id).up_timestamp;
                    if (dis_gateway === null) {
                        upPercentage = 0;
                    } else if (record.device_id === "0") {
                        upPercentage = 0;
                    } else {
                        upPercentage = 100;
                    }
                } else {
                    let down_time = 0;
                    for (let i of location_gt_level) {
                        if (i.up_timestamp === null) {
                            continue
                        }
                        if (i.up_timestamp > end_date_ts[1]) {
                            i.up_timestamp = end_date_ts[1]
                        }
                        down_time += (i.up_timestamp - i.down_timestamp);
                    }
                    if (down_time === 0) {
                        upPercentage = 0
                    } else {
                        let total_time = end_date_ts[1] - start_date_ts[0];
                        let up_time = total_time - down_time;
                        upPercentage = ((up_time / total_time) * 100);
                    }
                }

                return <span>{upPercentage.toFixed(2)} %</span>
            }
        },
        {
            title: "Alerts",
            dataIndex: 'location_id',
            render: (location_id) => {
                let count = 0;
                count = location_alerts[location_id] ? location_alerts[location_id].length : 0
                return <span>{count}</span>
            }
        }
    ];

    useEffect(() => {
        customerGatewayStats();
    }, []);

    useEffect(() => {
        if (site_level !== null) {
            fetchDevices();
            disconnectedGatewayStats();
            fetchNotifications();
        }
    }, [site_level]);

    useEffect(() => {
        if (disconnected_gt !== null) {
            fetchOverallUptime();
        }
    }, [disconnected_gt]);

    const disabledDate = (current) => {
        let allowed = current && (current > moment().endOf('day') || current < 30);
        if (!allowed) {
            let tooLate = dates && dates[0] && current.diff(dates[0], 'days') > 30;
            let tooEarly = dates && dates[1] && dates[1].diff(current, 'days') > 30;
            return allowed = (tooLate || tooEarly);
        }
        return allowed;
    };

    const onDateChange = (val) => {
        if (val) {
            let today = moment().startOf('day');
            if (val[0] && !val[1]) {
                let next30 = moment(val[0].format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day').add(30, 'days');
                val[1] = next30 > today ? today : next30;
            } else if (!val[0] && val[1]) {
                val[0] = moment(val[1].format('YYYY-MM-DD'), 'YYYY-MM-DD').subtract(30, 'days');;
            } else if (val[1].diff(val[0], 'days') > 30) {
                let next30 = moment(val[0].format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day').add(30, 'days');
                val[1] = next30 > today ? today : next30;
            }
            setDates(val);
        } else {
            setDates(date_defaults);
        }
    };

    const onOpenChange = (open) => {
        if (open) {
            setDates([]);
        }
    };

    const getDownloadReportUrl = () => {
        let start_date_ts = DateUtil.getUnixTimeStampInUTC('America/Chicago', moment(dates && dates[0]).format('YYYY-MM-DD'));
        let end_date_ts = DateUtil.getUnixTimeStampInUTC('America/Chicago', moment(dates && dates[1]).format('YYYY-MM-DD'));
        let site_info = user.site_selected.site_name + "_" + Buffer.from(user.user_login).toString('base64') + "_" + moment(dates && dates[0]).format('YYYY-MM-DD') + "_" + moment(dates && dates[1]).format('YYYY-MM-DD');
        var minifiedUser = preparePDFData({ ...user });
        minifiedUser.start_date_ts = start_date_ts[0];
        minifiedUser.end_date_ts = end_date_ts[1];
        minifiedUser.is_today = true;
        minifiedUser.save_report = true;
        minifiedUser.request_id = "Uptime Report - " + site_info + ".pdf";
        let url = "https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/pdf/uptime-report/Uptime Report - " + site_info + ".pdf?" + LZString.compressToBase64(JSON.stringify(minifiedUser)) + "=payload&host=" + window.location.host;
        return url;
    }

    const preparePDFData = (userCopy) => {
        var pdfData = {};
        let flds = ["user_login", "user_token", "customer_id", "site_id"];
        for (let i = 0; i < flds.length; i++) {
            pdfData[flds[i]] = userCopy[flds[i]];
        }

        if (userCopy.site_selected) {
            pdfData.site_selected = {};
            let flds = ["customer_id", "site_id", "site_name", "site_iana_timezone"];
            for (let i = 0; i < flds.length; i++) {
                pdfData.site_selected[flds[i]] = userCopy.site_selected[flds[i]];
            }
        }

        if (userCopy.zones) {
            pdfData.zones = [];
            for (let z of userCopy.zones) {
                pdfData.zones.push({
                    location_id: z.location_id,
                    location_name: z.location_name,
                    device_id: z.device_id,
                    location_operstatus: z.location_operstatus,
                    location_device_type: z.location_device_type,
                    location_unplugged: z.location_unplugged,
                    solar_pod_info: z.solar_pod_info
                });
            }
        }

        return pdfData;
    };

    const getDeviceCategory = async () => {
        var promises = [];
        for (var zone of user.zones) {
            if (zone.device_id && zone.location_device_type === 'axis') {
                promises.push(await controlCamera(zone.device_id));
            }
        };
        setDeviceCategory(promises);
        setLoading(false);
    }

    const controlCamera = (device_id) => {
        return new Promise(function (resolve, reject) {
            $.ajax(
                {
                    url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/axis-camera/info',
                    type: 'POST',
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    headers: {
                        user_login: user.user_login,
                        user_token: user.user_token
                    },
                    data: JSON.stringify({ device_id }),
                }
            ).then((res) => {
                if (res && res.status && res.status.code === 200) {
                    resolve({ device_id: device_id, device_category: res.data.device_category });
                } else {
                    resolve({});
                }
            }, (res) => {
                resolve({});
            })
        })
    }

    const fetchNotifications = () => {
        let start_date_ts = DateUtil.getUnixTimeStampInUTC('America/Chicago', moment(dates[0]).format('YYYY-MM-DD'));
        let end_date_ts = DateUtil.getUnixTimeStampInUTC('America/Chicago', moment(dates[1]).format('YYYY-MM-DD'));
        let data = {
            user_login: user.user_login,
            user_token: user.user_token,
            site_id: user.site_selected.site_id,
            form_input: {
                "query": JSON.stringify({
                    attributes: ["*"],
                    object: 'event_history',
                    filters: [
                        { attribute: 'dev_timestamp', value: end_date_ts[1], operator: '<=' },
                        { join_by: 'and', attribute: 'dev_timestamp', value: start_date_ts[0], operator: '>=' }
                    ],
                    sort_by: [{ attribute: 'dev_timestamp', value: 'asc' }],
                    pagination: { page: 1, size: 1000 }
                })
            }
        }

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/data-explorer',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res && res.status && res.status.code === 200) {
                    let location_alerts = {};
                    for (const loc of res.data) {
                        if (!location_alerts[loc.location_id]) {
                            location_alerts[loc.location_id] = [loc]
                        } else {
                            location_alerts[loc.location_id].push(loc);
                        }

                    }
                    setLocationAlerts(location_alerts);
                    getDeviceCategory();
                } else {
                    setLocationAlerts({});
                    getDeviceCategory();
                }

            })
    }

    const customerGatewayStats = () => {
        setLoading(true);
        let start_date_ts = DateUtil.getUnixTimeStampInUTC('America/Chicago', moment(dates[0]).format('YYYY-MM-DD'));
        let end_date_ts = DateUtil.getUnixTimeStampInUTC('America/Chicago', moment(dates[1]).format('YYYY-MM-DD'));
        let data = {
            customer_id: user.site_selected.customer_id,
            start_ts: start_date_ts[0],
            end_ts: end_date_ts[1],
            user_login: user.user_login,
            user_token: user.user_token
        }

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod//admin/device/customer-gateway-stats',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then((result) => {
            let results = result.data;
            let site_level = results.filter((s) => s.site_id === user.site_selected.site_id);
            setSiteLevel(site_level);
        });
    }

    const disconnectedGatewayStats = () => {
        var start_date_ts = DateUtil.getUnixTimeStampInUTC('America/Chicago', moment(dates[0]).format('YYYY-MM-DD'));
        let data = {
            site_id: user.site_selected.site_id,
            start_ts: start_date_ts[0],
            user_login: user.user_login,
            user_token: user.user_token
        }

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod//admin/device/disconnected-by-date',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then((result) => {
            let results = result.data;
            setDisconnectedGt(results);
            fetchOverallUptime();
        });
    }

    const fetchOverallUptime = () => {
        let arr = [];
        let upPercentage = 0;
        let start_date_ts = DateUtil.getUnixTimeStampInUTC('America/Chicago', moment(dates[0]).format('YYYY-MM-DD'));
        let end_date_ts = DateUtil.getUnixTimeStampInUTC('America/Chicago', moment(dates[1]).format('YYYY-MM-DD'));
        for (let zone of user.zones) {
            let location_gt_level = site_level.filter((l) => l.location_id === zone.location_id);
            if (zone.location_unplugged) {
                continue;
            }
            if (location_gt_level.length === 0) {
                let dis_gateway = disconnected_gt && disconnected_gt.find((d) => d.device_id === zone.device_id) && disconnected_gt.find((d) => d.device_id === zone.device_id).up_timestamp;
                if (dis_gateway === null) {
                    upPercentage = 0;
                } else if (zone.device_id === "0") {
                    upPercentage = 0;
                } else {
                    upPercentage = 100;
                }
            } else {
                let down_time = 0;
                for (let i of location_gt_level) {
                    if (i.up_timestamp === null) {
                        continue
                    }
                    if (i.up_timestamp > end_date_ts[1]) {
                        i.up_timestamp = end_date_ts[1]
                    }
                    down_time += (i.up_timestamp - i.down_timestamp);
                }
                if (down_time === 0) {
                    upPercentage = 0
                } else {
                    let total_time = end_date_ts[1] - start_date_ts[0];
                    let up_time = total_time - down_time;
                    upPercentage = ((up_time / total_time) * 100);
                }
            }

            arr.push(upPercentage)
        }
        let sum_uptime = arr.reduce((accumulator, currentValue) => accumulator + currentValue, 0);

        let total_length = arr.length * 100;
        let overAllUptime = (sum_uptime / total_length) * 100;
        setOverallUptime(overAllUptime);
    }

    const fetchDevices = () => {
        let data = {
            user_login: user.user_login,
            user_token: user.user_token,
            form_input: {
                query: JSON.stringify({
                    attributes: ['site_id', 'location_id', 'device_id', 'device_assetsn'],
                    object: 'device',
                    filters: [{ attribute: 'site_id', value: user.site_selected.site_id, operator: '=' }],
                    sort_by: [{ attribute: 'location_id', value: 'asc' }],
                    pagination: { page: 1, size: 1000 }
                }),
            }
        }

        $.ajax(
            {
                url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/data-explorer',
                type: 'POST',
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                data: JSON.stringify(data)
            }
        ).then(
            (res) => {
                if (res && res.status && res.status.code === 200) {
                    setDevices(res.data);
                } else {
                    setDevices([]);
                }
            });
    }

    return (
        <React.Fragment>
            <div className="modal-header p-2 bg-primary text-white">
                <span className="modal-title">{props.title}</span>
                <div>
                    <button type='button' className='fa fa-expand' onClick={props.resizeModal}></button>
                    <button type='button' className='far fa-lg fa-times-circle pull-right' data-dismiss='modal' onClick={props.closeModal}></button>
                </div>
            </div>
            {!loading && (
                <div className="container px-2 bg-light" >
                    <div className="row p-1">
                        <div className="col-md-4 font-weight-bold text-primary pt-1 pl-4">
                            {user && user.site_selected && user.site_selected.site_name}
                        </div>
                        <div className="col-md-8 text-right">
                            <span className='mr-2'><DownloadReport report_url={getDownloadReportUrl()}></DownloadReport></span>
                            <RangePicker
                                allowClear={false}
                                inputReadOnly='readonly'
                                defaultPickerValue={date_defaults}
                                onOpenChange={onOpenChange}
                                disabledDate={disabledDate}
                                defaultValue={dates}
                                onChange={onDateChange}
                                onCalendarChange={onDateChange}
                            />
                            <button disabled={!dates} className="btn btn-sm btn-primary" style={{ lineHeight: '23px', marginBottom: '2px', borderTopLeftRadius: '0px', borderBottomLeftRadius: '0px' }} onClick={() => customerGatewayStats()}>Submit</button>
                        </div>
                    </div>
                </div>
            )}

            {!loading &&
                <div className="row p-1">
                    <div className="col-md-12 pt-1" style={{ paddingLeft: "32px" }}>
                        <span className="font-size-5 mr-2">
                            <b>Overall Uptime:</b>&nbsp;<span>{overallUptime && overallUptime.toFixed(2)} %</span>
                        </span>
                    </div>
                </div>
            }

            <div className="modal-body bg-white">
                <div className="p-1">
                    <Table
                        loading={loading}
                        rowKey="location_id"
                        dataSource={loading ? [] : user.zones}
                        columns={report_columns}
                        pagination={false}
                    />
                </div>
            </div>
        </React.Fragment>
    );
}

export default UptimeReport;